import {ChecklistIcon} from '@primer/octicons-react'
import {Label} from '@primer/react'

import type {ItemCompletion} from '../../../../api/memex-items/side-panel-item'
import {TracksResources} from '../../../../strings'
import {TracksToken} from '../../../fields/tracks/tracks-token'
import styles from './tracks-label.module.css'

type Props = Readonly<{
  completion?: ItemCompletion
}>

export const TracksLabel: React.FC<Props> = ({completion}) => {
  if (!completion || completion.total === 0) {
    return null
  }

  const {completed, total} = completion
  const {tasks} = TracksResources

  const description = tasks(completed, total)
  return !completed ? (
    <Label size="large" variant="secondary" className={styles.Label}>
      <ChecklistIcon size={16} />
      <div className={styles.Text}>{description}</div>
    </Label>
  ) : (
    <TracksToken progress={completion} description={description} size="large" />
  )
}

try{ TracksLabel.displayName ||= 'TracksLabel' } catch {}